// eslint-disable-next-line no-shadow
export var TAlertStatus;
(function (TAlertStatus) {
    TAlertStatus["SUCCESS"] = "success";
    TAlertStatus["ERROR"] = "error";
    TAlertStatus["INFO"] = "info";
    TAlertStatus["WARNING"] = "warning";
    TAlertStatus["DEFAULT"] = "default";
})(TAlertStatus || (TAlertStatus = {}));
// eslint-disable-next-line no-shadow
export var TAlertType;
(function (TAlertType) {
    TAlertType["GENERAL"] = "general";
    TAlertType["TOP"] = "top";
    TAlertType["MIDDLE"] = "middle";
    TAlertType["BOTTOM"] = "bottom";
    TAlertType["IC_PAYMENT_UPDATE"] = "ic_payment_update";
    TAlertType["IC_ADDRESS_UPDATE"] = "ic_address_update";
    TAlertType["ABOVE_CHECKBOX"] = "above_checkbox";
    TAlertType["CHECKBOX_ERROR"] = "checkbox_error";
})(TAlertType || (TAlertType = {}));
